document.addEventListener("DOMContentLoaded", function() {
  const emailInputs = document.querySelectorAll(".password-content form .password-content__form-input[type=email]");
  if (emailInputs && emailInputs.length) {
    emailInputs.forEach(elem => {
      elem.blur();

      elem.focus = function () {
      return null;
    };
    })
  }

  window.scrollTo({
    top: 0,
  });

  new Swiper('.mobile-swiper-vertical', {
    direction: 'vertical', 
    slidesPerView: 1,     
    mousewheel: true,      
    speed: 600, 
    initialSlide: 0
  });

  const swiper = new Swiper('.mobile-slideshow', {
      loop: false,
      initialSlide: 1
    });

    const scrollBar = document.querySelector('.scroll-bar');

    swiper.on('slideChange', function () {
      const index = swiper.activeIndex;
      const total = swiper.slides.length;

      const shift = (index / (total - 1)) * 25;

      scrollBar.style.transform = `translateX(${shift}%)`;
    });

  const passwordSuccessMessages = document.querySelectorAll('.password-content form .password-content__form-message.password-content__form-message--success');
  if (passwordSuccessMessages && passwordSuccessMessages.length) {
    passwordSuccessMessages.forEach(elem => {
      elem.addEventListener('click', () => {
        elem.remove();
      })
    })

    setTimeout(() => {
      passwordSuccessMessages.forEach(elem => elem.remove())
    }, 5000);
  }
});

(function(){
  const desktopAnimationElems = document.querySelectorAll('.desktop-section .parallax-animation');
  if(!desktopAnimationElems.length) return;

  const isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  if (isTouch) return;

  const settings = {
    maxTranslate: 10,    // px, by XY
    maxRotate: 5,      // deg, rotateX/rotateY
    maxZ: 30,           // px, translateZ 
    scaleHover: 0.985,  // scale when hover 
    lerp: 0.14,
    activateDist: 200
  };

  let mouse = { x:0, y:0 };

  const elems = [];

  console.log(desktopAnimationElems)

  desktopAnimationElems.forEach(stage => {
    const children = stage.querySelectorAll(':scope > *');

    const stageState = { isInside: false };

    stage.addEventListener('mouseenter', () => {
      stageState.isInside = true;
      children.forEach(c => c.rect = c.getBoundingClientRect());
    });

    stage.addEventListener('mouseleave', () => {
      stageState.isInside = false;
    });

    stage.addEventListener('mousemove', e => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    });

    children.forEach(child => {
      elems.push({
        el: child,
        rect: child.getBoundingClientRect(),
        state: { tx:0, ty:0, tz:0, rx:0, ry:0, s:1 },
        get isInside(){ return stageState.isInside; } 
      });
    });
  });

  window.addEventListener('resize', () => {
    elems.forEach(item => item.rect = item.el.getBoundingClientRect());
  });

  function lerp(a,b,t){ return a + (b-a)*t; }

  function animate(){
    elems.forEach(item => {
      const rect = item.rect;
      const cx = rect.left + rect.width/2;
      const cy = rect.top + rect.height/2;

      const dx = mouse.x - cx;
      const dy = mouse.y - cy;
      const dist = Math.sqrt(dx*dx + dy*dy);

      let factor = 0;
      if(item.isInside && dist < settings.activateDist){
        factor = 1 - dist / settings.activateDist;
      }

      const nx = ((mouse.x - cx) / (rect.width/2));
      const ny = ((mouse.y - cy) / (rect.height/2));
      const clampedX = Math.max(-1, Math.min(1, nx));
      const clampedY = Math.max(-1, Math.min(1, ny));

      const target = {
        tx: clampedX * settings.maxTranslate * -factor,
        ty: clampedY * settings.maxTranslate * -factor,
        tz: -Math.abs(clampedX*settings.maxZ*factor + clampedY*settings.maxZ*factor),
        rx: -clampedY * settings.maxRotate * factor,
        ry: clampedX * settings.maxRotate * factor,
        s: settings.scaleHover + (1-settings.scaleHover)*(1-factor)
      };

      // lerp
      item.state.tx = lerp(item.state.tx, target.tx, settings.lerp);
      item.state.ty = lerp(item.state.ty, target.ty, settings.lerp);
      item.state.tz = lerp(item.state.tz, target.tz, settings.lerp);
      item.state.rx = lerp(item.state.rx, target.rx, settings.lerp);
      item.state.ry = lerp(item.state.ry, target.ry, settings.lerp);
      item.state.s  = lerp(item.state.s, target.s, settings.lerp);

      // apply
      item.el.style.transform = `
        translate3d(${item.state.tx.toFixed(2)}px, ${item.state.ty.toFixed(2)}px, ${item.state.tz.toFixed(2)}px)
        rotateX(${item.state.rx.toFixed(2)}deg)
        rotateY(${item.state.ry.toFixed(2)}deg)
        scale(${item.state.s.toFixed(3)})
      `;
    });

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
})();
